import React, { Component } from 'react';
import { ReactComponent as FbIcon } from './fb.svg';
import { ReactComponent as TwIcon } from './tw.svg';
import { ReactComponent as VkIcon } from './vk.svg';
import { ReactComponent as TgIcon } from './tg.svg';
import Btn from '../../components/btn';
// import html2canvas from 'html2canvas';
// import * as Canvas2Image from "canvas2image";
// const Canvas2Image = require('@senntyou/canvas2image');

export default class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            // image: ''
        };
        this.ref = React.createRef();
        // this.image = '';
        this.resultText = ``;
        this.resultTextShare = ``;
    }
    componentDidMount(){
        document.querySelector('.result').scrollIntoView();
    }
    // 	// this.setState({
    // 	// 	step: 10
    // 	// });
    // 	console.log(this.ref.current);
    // 	// Canvas2Image.saveAsPNG(this.ref.current, 400, 400);
    // 	html2canvas(this.ref.current).then(canvas => {
    // 		this.setState({
    // 			image: Canvas2Image.convertToPNG(canvas)
    // 		});
    // 		console.log(this.state.image.src);
    // 		// this.image = Canvas2Image.convertToPNG(canvas);
    // 		// document.querySelector('meta[property="og:image"]').setAttribute("content", screen);

    // 		// console.log(screen);
    // 		// this.ref.current.appendChild(canvas);
    // 	});
    // }
    render() {
        
        const { score } = this.props;
        if (score === 10) {
            this.resultText = `Ну это win, без вопросов.`;
            this.resultTextShare = `Отправьте тест друзьям — пусть знают, что вы разбираетесь в датавизе:`;
        } else if (score >= 5) {
            this.resultText = (<>
                    <p>Вы разбираетесь в датавизе, но можете еще лучше.</p>
                    <p>
                        Подписывайтесь на{' '}
                        <a
                            href='https://t.me/storylanding'
                            target='_blank'
                            rel='noreferrer'>
                            наш Телеграм
                        </a>
                        , чтобы развивать насмотренность.
                    </p>
                </>
            );
            this.resultTextShare = `Отправляйте тест друзьям, чтобы проверить их знания в датавизе:`;
        } else {
            this.resultText = <p>Что-то маловато. Пройдите тест еще разок или подписывайтесь на <a
            href='https://t.me/storylanding'
            target='_blank'
            rel='noreferrer'>
            наш Телеграм
        </a>, чтобы развивать насмотренность</p>;
            this.resultTextShare = `Отправляйте тест друзьям, чтобы проверить их знания в датавизе:`;
        }

        return (
            <div className='result'>
                <div className='container'>
                    <div className='result__inner' ref={this.ref}>
                        <div className='result__title'>{`Воу ${score} из 10`}</div>
                        <div className='result__text'>
                            {this.resultText}
                        </div>
                        <div className='result__desc'>
                            {this.resultTextShare}
                        </div>
                        <div className='result__socials'>
                            <a
                                href={`https://www.facebook.com/sharer/sharer.php?u=https://infografika.agency/dataviz-test/`}
                                className='result__social'>
                                <span className='result__social-icon'>
                                    <FbIcon />
                                </span>
                                <span className='result__social-text'>Share</span>
                            </a>
                            <a
                                href='https://twitter.com/share?text=Тренажер насмотренности в датавизе — проверьте, знаете ли вы, какие графики применять, чтобы не искажать информацию&url=https://infografika.agency/dataviz-test/'
                                className='result__social'>
                                <span className='result__social-icon'>
                                    <TwIcon />
                                </span>
                                <span className='result__social-text'>Tweet</span>
                            </a>
                            <a
                                href={`https://vk.com/share.php?url=https://infografika.agency/dataviz-test/&title=Тренажер насмотренности в датавизе — проверьте, знаете ли вы, какие графики применять, чтобы не искажать информацию&noparse:true`}
                                className='result__social'>
                                <span className='result__social-icon'>
                                    <VkIcon />
                                </span>
                                <span className='result__social-text'>Share</span>
                            </a>
                            <a
                                href='https://t.me/share/url?url=https://infografika.agency/dataviz-test/'
                                className='result__social'>
                                <span className='result__social-icon'>
                                    <TgIcon />
                                </span>
                                <span className='result__social-text'>Send</span>
                            </a>
                        </div>
                        <Btn
                            className='result__btn'
                            onClick={this.props.updatePage.bind(this, 1)}>
                            Еще раз
                        </Btn>
                    </div>
                </div>
            </div>
        );
    }
}
